export default __webpack_public_path__ + "static/media/cha4.f69b6953.png";